'use client';

import { APPLICATION_STORAGE_KEY } from '@/components/features/Applications/ApplicationForm/ApplicationForm.utils';
import { css, cx } from '@onbeam/business-styled-system/css';
import { isBrowser } from '@onbeam/utils';
import { ComponentProps, useEffect, useState } from 'react';

export const FormProgressPingContainer = ({
  children,
  className,
}: ComponentProps<'div'>) => {
  const [hasSavedProgress, setHasSavedProgress] = useState(false);

  useEffect(() => {
    if (!isBrowser) return;
    const savedProgress = localStorage.getItem(APPLICATION_STORAGE_KEY);
    setHasSavedProgress(!!savedProgress);
  }, []);

  return (
    <div className={cx(css({ position: 'relative' }), className)}>
      {children}
      {hasSavedProgress && (
        <div
          aria-hidden
          className={css({
            h: '[1rem]',
            w: '[1rem]',
            bg: 'red.primary',
            border: '1.5px solid',
            borderColor: 'red.40',
            position: 'absolute',
            top: '0',
            right: '0',
            transform: 'translateY(-50%)',
            rounded: 'full',
          })}
        />
      )}
    </div>
  );
};
